import api from '../../../api/axios';
import { API_ENDPOINTS } from '../../../api/endpoints';
import { unwrapApiResponse } from '../../../api/responseNormalizer';
import {
  vesselPlanningApi,
  type VesselPlanningSaleOrderBulkDatesRequest,
  type VesselPlanningSaleOrderBulkUpdateResponse,
} from '../../vessel-planning/api/vesselPlanningApi';
import type { DismissVesselChangeRequest } from '../types/vesselChanges';

/** Hides one job's leg until PTP's times for the call change again. */
export const dismissVesselChange = async (request: DismissVesselChangeRequest): Promise<void> => {
  await api.post(API_ENDPOINTS.VESSEL_CHANGES.DISMISS, request);
};

/** "Not this vessel": closes a LINK alert; it is not raised again for that job and vessel name. */
export const closeVesselAlert = async (alertId: number): Promise<void> => {
  const { data } = await api.post(API_ENDPOINTS.VESSEL_CHANGES.ALERT_CLOSE(alertId));
  unwrapApiResponse<boolean>(data);
};

/** The existing Vessel Planning bulk update (`sale-order-update-many`), with one leg's dates only. */
export const updateJobDates = (
  request: VesselPlanningSaleOrderBulkDatesRequest
): Promise<VesselPlanningSaleOrderBulkUpdateResponse> => vesselPlanningApi.updateSaleOrders(request);
